import { render } from "./Departments.vue?vue&type=template&id=7d3d4a61&ts=true"
import script from "./Departments.vue?vue&type=script&lang=ts"
export * from "./Departments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__